"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var ThumbUp = function ThumbUp(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "40",
    height: "40",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 5.25,21.751c0.527,0.008,1.051,0.085,1.558,0.23l3.634,1.038c0.536,0.153,1.09,0.231,1.647,0.231h4.885 c3.081,0,5.662-2.334,5.97-5.4l0.3-5.1c0.109-2.147-1.315-4.071-3.4-4.594l-1.455-0.318C17.72,7.672,17.25,7.071,17.25,6.382V3 c0-1.243-1.007-2.25-2.25-2.25S12.75,1.757,12.75,3v1.554c0,4.142-3.358,7.5-7.5,7.5V21.751z ",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 0.75,9.75h4.5v13.5h-4.5V9.75z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  })));
};
ThumbUp.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
ThumbUp.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = ThumbUp;